import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { computed } from 'vue'
import i18n from '@/VueI18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyFireOutbreakList',
  setup(__props) {

const title = computed(() => i18n.t('fireRiskDashboardNoRecords'))

const subtitle = computed(() => i18n.t('fireRiskDashboardWaitForAlerts'))

const icon = computed(() => 'fa6-solid:folder-open')

return { __sfc: true,title, subtitle, icon, Icon }
}

})